import { forwardRef } from 'react';
import { ButtonLink, Stack } from '@kiwicom/orbit-components';
import { ChevronDown } from '@kiwicom/orbit-components/icons';
import { ChevronUp } from '@kiwicom/orbit-components/icons';
import { FormattedMessage } from 'react-intl';

type Props = {
  readonly onClick: () => void;
  readonly dataTest?: string;
  readonly isLoading?: boolean;
  readonly isShowLessButtonVisible?: boolean;
};

export default forwardRef<HTMLButtonElement, Props>(function ShowMoreButton(props: Props, ref) {
  return (
    <Stack justify="center" align="center">
      <ButtonLink
        dataTest={props.dataTest}
        ref={ref}
        type="secondary"
        size="normal"
        onClick={props.onClick}
        iconRight={props.isShowLessButtonVisible ? <ChevronUp /> : <ChevronDown />}
        loading={props.isLoading}
      >
        {props.isShowLessButtonVisible ? (
          <FormattedMessage id="account_v2.components.show_less" defaultMessage="Show less" />
        ) : (
          <FormattedMessage id="account_v2.components.show_more" defaultMessage="Show more" />
        )}
      </ButtonLink>
    </Stack>
  );
});
